import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Skills.css';

function Skills() {
  const [skills, setSkills] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await axios.get('/api/skills');
        setSkills(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching skills:', error);
        setLoading(false);
      }
    };

    fetchSkills();
  }, []);

  if (loading) {
    return <div className="loading">Loading skills...</div>;
  }

  const renderSkillCategory = (title, skillList) => (
    <div key={title} className="skill-category">
      <h3>{title}</h3>
      <div className="skills-list">
        {skillList.map((skill, index) => (
          <div key={index} className="skill-item">
            <span className="skill-badge">{skill}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <section className="section section-light">
      <div className="container">
        <h2>My Skills</h2>
        <p className="section-intro">
          A comprehensive overview of my technical expertise and proficiencies
        </p>

        <div className="skills-container">
          {skills && (
            <>
              {renderSkillCategory('Frontend Development', skills.frontend)}
              {renderSkillCategory('Backend Development', skills.backend)}
              {renderSkillCategory('Tools & Technologies', skills.tools)}
              {renderSkillCategory('Soft Skills', skills.other)}
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default Skills;